export function createSchemaField({
  name,
  label,
  fieldDescription,
  type,
  targetType,
  templateKeys,
  defaultValue,
  defaultUnit,
  options,
  enumOptionsSort,
  source,
  inherited = false,
} = {}) {
  const field = {
    name,
    label,
    fieldDescription: String(fieldDescription || '').trim(),
    type,
    default: defaultValue,
    options,
    secured: false,
    visible: true,
    required: false,
    indexed: false,
    logged: false,
    columnWidth: null,
    hidden: false,
    inherited: Boolean(inherited),
  };

  if (type === 'enum') {
    field.enumOptionsSort = typeof enumOptionsSort === 'string' && enumOptionsSort.trim().length
      ? enumOptionsSort.trim().toLowerCase()
      : 'manual';
  }

  if (type === 'nodelist') {
    field.targetType = String(targetType || '').trim();
  }

  if (type === 'checklist') {
    field.templateKeys = (Array.isArray(templateKeys) ? templateKeys : [])
      .map((key) => String(key || '').trim())
      .filter(Boolean);
  }

  if (type === 'measurement') {
    field.defaultUnit = String(defaultUnit || '').trim();
  }

  if (source) {
    field.source = source;
  }

  if (!field.fieldDescription) {
    delete field.fieldDescription;
  }

  return field;
}

export function insertSchemaFieldAtVisibleIndex(baseFields, visibleFields, index, newField) {
  const base = Array.isArray(baseFields) ? [...baseFields] : [];
  const visible = Array.isArray(visibleFields) ? visibleFields : [];
  const safeIndex = typeof index === 'number' ? index : visible.length;

  if (safeIndex <= 0) {
    base.unshift(newField);
    return base;
  }

  if (safeIndex >= visible.length) {
    base.push(newField);
    return base;
  }

  const anchor = visible[safeIndex];
  if (!anchor?.name) {
    base.push(newField);
    return base;
  }

  const baseIndex = base.findIndex((field) => field?.name === anchor.name);
  if (baseIndex < 0) {
    base.push(newField);
    return base;
  }

  base.splice(baseIndex, 0, newField);
  return base;
}